import { Card, Form, Input, Upload, Typography, Button, message, Row, Col, Spin } from "antd";
import React, { useEffect, useState } from "react";
import readXlsxFile from "read-excel-file";
import { useLocation } from "react-router-dom";
import { useId24 } from "../../../drivers/id24/Id24Provider";
import { UploadOutlined, LoadingOutlined } from "@ant-design/icons";
import { loadAppConfig } from "../../../configs/app-config";
import { Activityservice } from "../services/importfile.service";

const antIcon = <LoadingOutlined className="text-[24px]" spin />;

export const ImportFile: React.FC = () => {
  const { id24Axios } = useId24();
  const apiBaseUrl = id24Axios(loadAppConfig().REACT_APP_API_BASE_URL);
  const location = useLocation();
  const [getdataResult, setdataResult] = useState<any>([]);
  const [fileList, setFileList] = useState<any>([]);
  const [loadingStatus, setLoadingStatus] = useState<boolean>(false);

  useEffect(() => {
    setdataResult(location.state);
  }, [location.state]);

  const props = {
    onRemove: (file: any) => {
      const index = fileList.indexOf(file);
      const newFileList = fileList.slice();
      newFileList.splice(index, 1);
      setFileList(newFileList);
    },
    beforeUpload: (file: any) => {
      const isPDF = file.type === "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
      if (!isPDF) {
        message.error(`${file.name} is not a excel file`);
      } else {
        setFileList([...fileList, file]);
        return false;
      }
    },
    fileList,
  };

  const onfinish = async (event: any) => {
    var formData = new FormData();
    formData.append("file", fileList[0]);
    const dataImport: any = [];
    readXlsxFile(fileList[0]).then(async (rows: any) => {
      rows.forEach((item: string, i: number) => {
        if (i > 0) {
          if (!item[3]) {
            return;
          } else {
            dataImport.push({
              fullName: item[0],
              company: item[1],
              position: item[2],
              email: item[3],
              phone: item[4],
              department: item[5],
            });
          }
        }
      });
      await Activityservice(apiBaseUrl)
        .importfileExcel(String(event.agendaId), dataImport)
        .then((resultCreate) => {
          setLoadingStatus(true);
          if (resultCreate) {
            setLoadingStatus(false);
          }
          message.success("สำเร็จ");
        });
    });
  };

  return loadingStatus ? (
    <Spin indicator={antIcon} />
  ) : (
    <>
      <div className="divHeader">
        <Typography.Text className="headerText">{`IMPORT FILE`}</Typography.Text>
        <br />
        <Typography.Text>{`import ผู้เข้าร่วมกิจกรรม`}</Typography.Text>
      </div>
      <div className="divContent">
        <Card title={`รายละเอียดกิจกรรม`}>
          {getdataResult && (
            <Form
              onFinish={onfinish}
              labelCol={{ span: 4 }}
              wrapperCol={{ span: 14 }}
              name="form"
              fields={[
                {
                  name: ["agendaId"],
                  value: `${getdataResult?.agendaId}`,
                },
                {
                  name: ["name"],
                  value: `${getdataResult?.name}`,
                },
                {
                  name: ["description"],
                  value: getdataResult?.description,
                },
                {
                  name: ["number"],
                  value: getdataResult?.number,
                },
                {
                  name: ["numberChar"],
                  value: getdataResult?.numberChar,
                },
                {
                  name: ["type"],
                  value: getdataResult?.type,
                },
              ]}
            >
              <Form.Item name={"agendaId"} label={`agendaId`} hidden />
              <Row>
                <Col span={12}>
                  <Form.Item name={"name"} label={`name`}>
                    <Input className="input" readOnly />
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item name={"description"} label={`description`}>
                    <Input className="input" readOnly />
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item name={"number"} label={`number`}>
                    <Input className="input" readOnly />
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item name={"numberChar"} label={`numberChar`}>
                    <Input className="input" readOnly />
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item name={"type"} label={`type`}>
                    <Input className="input" readOnly />
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item name={"uploads"} label={``}>
                    <Upload {...props}>
                      <Button icon={<UploadOutlined />}>Upload</Button>
                    </Upload>
                  </Form.Item>
                </Col>
                <Col span={24} className="flex justify-center">
                  <Form.Item>
                    <Button htmlType="submit" type="default" disabled={fileList === null || fileList === undefined ? true : false}>{`ยันยัน`}</Button>
                  </Form.Item>
                </Col>
              </Row>
            </Form>
          )}
        </Card>
      </div>
    </>
  );
};
